import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";
import { PAYMENT } from "@/constants/testIds";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";

export default function PaymentCancel() {
    return (
        <div>
            <Navbar />
            <main className="min-h-[80vh] flex items-center justify-center px-5 pt-32 pb-24">
                <div data-testid={PAYMENT.cancelCard} className="max-w-xl w-full bg-[#141414] border border-white/10 p-10 sm:p-14 text-center">
                    <XCircle className="w-14 h-14 mx-auto mb-6 text-white/50" />
                    <div className="eyebrow mb-3">Checkout cancelled</div>
                    <h1 className="font-display font-semibold text-4xl tracking-[-0.03em] text-white">No worries — you can retry anytime.</h1>
                    <p className="mt-6 text-white/70 leading-relaxed">
                        Your card wasn't charged. If you had questions before checking out, WhatsApp us — often we clear them up in 2 minutes.
                    </p>
                    <div className="mt-10 flex flex-col sm:flex-row gap-3 justify-center">
                        <Link to="/#packages" className="inline-flex items-center justify-center bg-brand hover:bg-brand-hover text-white font-semibold px-6 py-3 transition-colors">
                            View packages again
                        </Link>
                        <a
                            href="https://wa.me/971543676278"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="inline-flex items-center justify-center border border-white/20 hover:border-white/60 text-white font-semibold px-6 py-3 transition-colors"
                        >
                            Ask a question
                        </a>
                        <Link to="/" data-testid={PAYMENT.backHome} className="inline-flex items-center justify-center text-white/60 hover:text-brand px-6 py-3 transition-colors text-sm font-mono uppercase tracking-widest">
                            Home
                        </Link>
                    </div>
                </div>
            </main>
            <Footer />
        </div>
    );
}
